import { render, staticRenderFns } from "./elementButton.vue?vue&type=template&id=0610460d"
import script from "./elementButton.vue?vue&type=script&lang=ts"
export * from "./elementButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports